import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { useMedia } from 'react-media';
import { Container } from 'semantic-ui-react';
import AppHeader from '../../../components/AppHeader';
import AppMenu from '../../../components/menu/AppMenu';
import AppSecondaryMenu from '../../../components/menu/AppSecondaryMenu';
import MenuMobile from '../../../components/menu/MenuMobile';
import { useConfig } from '../../../config/config.context';
import { useDesignConfig } from '../../../config/design.context';
import { GLOBAL_MEDIA_QUERIES } from '../../../utils/mediaQueries';

// TODO : transformer en Menus ?
export const HorizontalMenu = ({ menu }) => {
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const { lang, languages, menus } = useConfig();
  const design = useDesignConfig();
  const { menu: menuConfig = {} } = design;
  if (matches.mobile) {
    return (
      <MenuMobile
        menu={[
          ...menu?.map((m) => ({ ...m, menuType: 'main' })),
          ...get(menus, ['secondary', 'entries'], []).map((m) => ({ ...m, menuType: 'secondary' })),
        ].filter((m) => m.type !== 'search')}
        language={lang}
        languageOptions={languages}
        design={design}
      />
    );
  }

  return (
    <div>
      {matches.desktop && (
        <div className="menu-secondary-wrapper">
          <Container>
            <AppSecondaryMenu menu={menus?.secondary} />
          </Container>
        </div>
      )}
      <div
        className={`menu-wrapper menu-wrapper--${get(menuConfig, 'wrapper.variant', 'logoTop')}`}
      >
        <Container>
          <AppHeader language={lang} languageOptions={languages} />
          <AppMenu menu={menu} menuConfig={menuConfig} variant={menuConfig?.entries?.variant} />
        </Container>
      </div>
    </div>
  );
};

HorizontalMenu.defaultProps = {
  menu: [],
};

HorizontalMenu.propTypes = {
  menu: PropTypes.arrayOf(PropTypes.object),
};
